import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/aircraft/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
